module.exports = __webpack_public_path__ + "img/revenueStatistics.93585b42.svg";